/**
 * Heat Loss Calculator
 * ===
 * Surface Model
 * 
 * Extends Backbone Model.
 *
 * Author: Duncan McMillan
 *
 * Copyright (c) August 2024 · Art & Soul Communications Ltd.
 * https://artandsoul.co.uk
 *
 */

'use strict';

import Backbone from 'backbone';

export var SurfaceModel = Backbone.Model.extend({
    
    defaults: {
        x: 0,
        y: 0,
        uvalue: 0,
        fixture_uvalue: 0,
        fixture_area: 0
    },
    
    room: undefined,
    
    initialize: function(attributes, options) {
        
        this.room = options.room;
        
        return this;
    },
    
    /**
     * Area
     *
     */
    area: function() {
        
        var total_area;
        
        total_area = this.get('x') * this.get('y');
        
        return total_area - this.getFixtureArea();
    },
    
    getFixtureArea: function() {
        
        var total_area, fixture_area;
        
        total_area = this.get('x') * this.get('y');
        fixture_area = 0;
        
        if (this.has('fixture_area') && this.get('fixture_area') < total_area) {
            fixture_area = this.get('fixture_area');
        }
        
        return fixture_area;
    },
    
    /**
     * Temperature Difference
     * 
     */
    temperatureDifference: function() {
        return this.room.get('temperature') - this.get('adjacent_temperature'); 
    },
    
    /**
     * Fabric Heat Loss
     * 
     */
    fabricHeatLoss: function() {
        
        var surface_loss, fixture_loss;
        
        surface_loss = this.area() * this.get('uvalue');
        fixture_loss = this.getFixtureArea() * this.get('fixture_uvalue');
        
        return (surface_loss + fixture_loss) * this.temperatureDifference(); 
    }
    
});
